import { render, staticRenderFns } from "./projectName.vue?vue&type=template&id=48a55e00&scoped=true"
import script from "./projectName.vue?vue&type=script&lang=js"
export * from "./projectName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a55e00",
  null
  
)

export default component.exports